<kendo-window title="Consoles" *ngIf="opened" (close)="close()" [minWidth]="1080" [width]="1280" [minHeight]="570" [height]="650" [resizable]="false" [draggable]="true" [modal]="true">
  <kendo-window-messages closeTitle="Fermer"></kendo-window-messages>
  <div #devicesMount class="devices-mount"></div>
    <div class="text-right">

    <button type="button" class="k-button k-primary" (click)="close()"
     >Fermer</button>
  </div>
</kendo-window>
